//Components
import SurveyTemplateList from './SurveyTemplateList';
import AlertSaveButton from '../../../../button/AlertSaveButton';
import Module from '../../../../../components/layout/Module';

//Other dependencies
import { useNavigate, useMatch } from 'react-router-dom';
import { resetState } from '../../../../../store/actions/dataEntryTemplateGeneratorActions';
import { useDispatch, useSelector } from 'react-redux';

const SurveyTemplates = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const match = useMatch('/generator/assessment-templates');
  const url = match ? match.pathname : '';
  const permissions = useSelector((state) => state?.session?.permissions?.templatesurveygenerator || {});
  const currentModule = 'templatesurveygenerator';

  const redirect = (redirectTo) => {
    navigate(`${url}/${redirectTo}`);
  };

  const onCreateTemplate = () => {
    dispatch(resetState());
    redirect('dashboard/data-entry/generator/survey-templates/add');
  };

  return (
    <Module>
      <Module.Header
        moduleName={currentModule}
        title='Survey Templates'
        titleLink={'/dashboard/data-entry/generator/survey-templates'}
      >
        <div className='flex justify-end items-center gap-2'>
          {permissions?.create && (
            <AlertSaveButton
              submodule={currentModule}
              icon='circle-check'
              title='Create Template'
              color='secondary'
              onDontSave={onCreateTemplate}
            />
          )}
        </div>
      </Module.Header>
      <Module.Body>
        <SurveyTemplateList />
      </Module.Body>
    </Module>
  );
};
export default SurveyTemplates;
